<app-unauth-main-layout
  [desktopVideoUrl]="desktopBackgroundVideo"
  [tabletVideoUrl]="tabletBackgroundVideo"
  [mobileVideoUrl]="mobileBackgroundVideo"
  ><div class="content-wrapper">
    <div [innerHTML]="body | safeHtml" *ngIf="showForm"></div>
    <form
      [formGroup]="formGroup"
      class="d-flex flex-column align-items-start justify-content-center w-100"
      (ngSubmit)="onSubmit()"
    >
      <div class="form-row p-1 w-100">
        <input
          id="newPassword"
          type="password"
          formControlName="newPassword"
          placeholder="New password"
          class="w-100"
        />
        <p class="password-rules">
          {{ 'password_rules_text' | translate }}
        </p>
      </div>
      <div class="form-row p-1 w-100">
        <input
          id="confirmedPassword"
          type="password"
          formControlName="confirmedPassword"
          placeholder="Confirm password"
          class="w-100"
        />
      </div>
      <div class="form-row w-100 pt-4">
        <div class="d-flex align-items-start justify-content-start w-100">
          <button class="btn btn-primary" type="submit">Save Password</button>
        </div>
      </div>
    </form>
  </div></app-unauth-main-layout
>
